import { MenuItem, Select } from '@mui/material';
import { useState } from 'react';

export const ContactabilidadEditCell = ({
    params,
    contactabilidades,
    campana,
}) => {
    const [open, setOpen] = useState(true);

    const handleChange = (event) => {
        const selectedId = event.target.value;
        const selected = contactabilidades.find((c) => c.id === selectedId);

        params.api.setEditCellValue(
            {
                id: params.id,
                field: params.field,
                value: selected,
            },
            event,
        );

        params.api.stopCellEditMode({
            id: params.id,
            field: params.field,
        });
    };

    return (
        <Select
            value={params.value?.id || ''}
            onChange={handleChange}
            open={open}
            onOpen={() => setOpen(true)}
            onClose={() => setOpen(false)}
            fullWidth
            autoFocus
            variant="standard"
        >
            {contactabilidades.map((option) => (
                <MenuItem key={option.id} value={option.id}>
                    {option.nombre === 'Preventa' && campana.division?.id === 2
                        ? 'Donación Efectiva'
                        : option.nombre}
                </MenuItem>
            ))}
        </Select>
    );
};
